import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Self-Assessment: the questionnaire dashboard and the employee
 * list.
 *
 * Built on the assessment run — one row per person per questionnaire, written
 * on the first answer and completed on the last. The details a person fills in
 * before starting (dob, ethnicity, job role, medication and GP answers) are
 * never surfaced anywhere in this section.
 */
const CompanySelfAssessmentLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Assessment Dashboard',
      path: `/${slug}/self-assessment`,
      description: 'Take-up, the start-to-finish funnel and where people land on each assessment'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/self-assessment/users`,
      description: `Per-${population.replace(/s$/, '')} assessment records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Self-Assessment"
      subtitle={`Which questionnaires your ${population} take, how many finish them, and where the results land.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanySelfAssessmentLayout;
